import controller from './side-banners.controller';
import template from './side-banners.view.html';

let SideBannersComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default SideBannersComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/banners/side-banners/side-banners.component.js
 **/